import type { ReactNode } from 'react'
import { copy } from './copy'

export function CenteredMessage({ children, alert = false }: { children: ReactNode; alert?: boolean }) {
  return (
    <main role={alert ? 'alert' : undefined} className="flex min-h-screen items-center justify-center p-8 text-center">
      {alert ? <h1 className="text-xl font-semibold">{children}</h1> : <p>{children}</p>}
    </main>
  )
}

export function RetryScreen({ title, onRetry }: { title: string; onRetry: () => void }) {
  return (
    <main role="alert" className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-xl font-semibold">{title}</h1>
      <button
        type="button"
        onClick={onRetry}
        className="rounded border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50"
      >
        {copy.access.retry}
      </button>
    </main>
  )
}
